import { createFileRoute } from "@tanstack/react-router";

import { BucketPageContainer } from "@/pages/BucketPage";

export const Route = createFileRoute(
  "/_app/(taxonomy)/topic/$tab/$topicId/$groupId/{-$subtopicId}",
)({
  component: () => <BucketPageContainer />,
  validateSearch: (search) => search,
});
